module.exports = __webpack_public_path__ + "static/media/terms_of_service.d8e1ecac.md";